export default {
  AGREEMENT_FETCHED: 'AGREEMENT_FETCHED',
  AGREEMENT_LOAD: 'AGREEMENT_LOAD',
  AGREEMENT_TEMPLATES_FETCHED: 'AGREEMENT_TEMPLATES_FETCHED',
  AGREEMENT_TEMPLATES_LOAD: 'AGREEMENT_TEMPLATES_LOAD',
  AGREEMENT_DETAIL: 'AGREEMENT_DETAIL',
  AGREEMENT_BUTTON_LOAD: 'AGREEMENT_BUTTON_LOAD',
};
